export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-drive-a6d881a6ab1cb0e778a8936a13ccaeb6.svg";